import React from 'react';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';

export const ProfileLayout = ({ children }) => {
  return (
    <Flex flexDirection="column">
      <Text
        variant="h4"
        sx={{
          lineHeight: '28px'
        }}
      >
        Content Profile
      </Text>
      {children}
    </Flex>
  );
};
